// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__ICgJt","title":"Card_title__9CvSU"};